import { APP_ID, NOTIFIES } from '../../../constants/system.keys';
import {
  base64ToUnit8Array,
  convertToBase64URL,
} from '../../../helpers/common';
import {
  checkLDAPAccount,
  getChallengeAuthenRegisterWebAuthn,
} from '../../../hooks/socket/auth';
import { openMessage, socketEmitEvent } from '../../../redux/actions';
import { Button, Form, Input, Select } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import * as SERVICE from '../../../constants/service.types';
import { useDispatch, useSelector } from 'react-redux';
import { FingerprintIcon } from '../../../icons/Fingerprint';
import { DangerIcon } from '../../../icons/Danger';
import { CheckGreenIcon } from '../../../icons/CheckGreen';
import './LoginPasskey.scss';

export const LoginByPasskey = ({ onBack }) => {
  const [ldapData, setLDAPData] = useState([]);
  const [challengePasskey, setChallengePasskey] = useState(null);

  const onInputBlur = (e) => {
    console.log(e.target.value);

    checkLDAPAccount({
      username: e.target.value,
      appId: APP_ID,
    }).then((res) => {
      setLDAPData(res);
    });
  };

  const onContinue = async (data) => {
    const { username, namespace } = data;
    const credentialId = ldapData.find(
      (item) => item.namespace === namespace
    )?.credentialId;

    if (!credentialId) {
      openMessage(
        NOTIFIES.ERROR,
        'You have not registered passkey on this account'
      );
      return;
    }

    const challengePasskey = await getChallengeAuthenRegisterWebAuthn({
      appId: APP_ID,
      phonenumber: username,
    });

    setChallengePasskey(challengePasskey);
  };

  const formContent = () => {
    return (
      <div className="login-passkey-form-container">
        <Form
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 0 }}
          className="login-passkey-form"
          onFinish={onContinue}
          style={{ maxWidth: 400 }}
        >
          <p className="login-passkey-form-title">Login by passkey</p>
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please enter your username' }]}
          >
            <Input
              size="large"
              placeholder="Enter your username"
              onBlur={onInputBlur}
            />
          </Form.Item>
          <Form.Item
            name="namespace"
            rules={[
              { required: true, message: 'Please select your namespace' },
            ]}
          >
            <Select
              options={ldapData.map((item) => ({
                label: item.namespace,
                value: item.namespace,
              }))}
              size="large"
              placeholder="Select your namespace"
            />
          </Form.Item>

          <div className="login-passkey-form-button-container">
            <Button size="large" htmlType="submit" onClick={onBack}>
              Back
            </Button>
            <Button size="large" htmlType="submit">
              Continue
            </Button>
          </div>
        </Form>
      </div>
    );
  };

  const content = () => {
    if (challengePasskey) {
      return (
        <VerifyPasskey onBack={onBack} challengePasskey={challengePasskey} />
      );
    }

    return formContent();
  };

  return content();
};

export const VerifyPasskey = ({ onBack, challengePasskey }) => {
  /**
   * null: not start
   * undefined: error
   * PublicKeyCredential: success
   */
  const [credential, setCredential] = useState(null);
  const language = useSelector((state) => state.language);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const onStart = async () => {
    try {
      const credential = await navigator.credentials.get({
        publicKey: {
          challenge: base64ToUnit8Array(challengePasskey.challenge),
          allowCredentials: [
            {
              type: 'public-key',
              id: base64ToUnit8Array(challengePasskey.credentialId),
            },
          ],
          userVerification: 'preferred',
        },
      });

      setCredential(credential || undefined);
    } catch (error) {
      setCredential(undefined);
      console.error(error);
    }
  };

  const onContinue = useCallback(
    (challengePasskey, credential) => {
      const credResponse = credential.response;

      const dataObj = {
        appServiceType: SERVICE.LOGIN_WEB_AUTHN,
        requestId: new Date().getTime(),
        body: JSON.stringify({
          namespace: challengePasskey.namespace,
          username: challengePasskey.username,
          appId: APP_ID,
          signature: convertToBase64URL(credResponse.signature),
          clientDataJSON: convertToBase64URL(credResponse.clientDataJSON),
          authenticatorData: convertToBase64URL(credResponse.authenticatorData),
          language,
          agent: `${window.navigator.userAgent}_web`,
        }),
      };
      dispatch(socketEmitEvent(dataObj));
      setIsLoading(true);
    },
    [language]
  );

  const onTryAgain = () => {
    onStart();
  };

  useEffect(() => {
    if (credential && challengePasskey) {
      const timeout = setTimeout(() => {
        onContinue(challengePasskey, credential);
      }, 2000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [credential, challengePasskey, onContinue]);

  return (
    <div className="verify-passkey">
      <p className="verify-passkey-title">Verify your identity</p>
      <p className="verify-passkey-subtitle">
        {credential ? 'We are logging you in...' : "We need to verify it's you"}
      </p>

      <div className="verify-passkey-icon-container">
        {credential === null && <FingerprintIcon color="#EAEEF1" />}
        {credential === undefined && <DangerIcon />}
        {credential && <CheckGreenIcon />}
      </div>

      <div className="verify-passkey-button-container">
        {!credential && <Button onClick={onBack}>Back</Button>}
        {credential === null && <Button onClick={onStart}>Start</Button>}

        {credential === undefined && (
          <Button onClick={onTryAgain}>Try again</Button>
        )}
      </div>
    </div>
  );
};
